<template>
  <div class="fileSystem">
  <div class="actions">
    <div class="dbButton" @click="openNew"><span class="material-symbols-outlined newFile">note_add</span></div>
    <div class="dbButton" @click="createFolder"><span class="material-symbols-outlined">create_new_folder</span></div>
    <div class="dbButton" @click="fetchData"><span class="material-symbols-outlined">refresh</span></div>
  </div>
    <div ref="pathContainer" class="path">
      <VueDraggable
        v-model="internalTreeData"
        animation="150"
        ghostClass="ghost"
        class="container"
        group="fileSystem"
        :sort = false
      >
    <div v-for="node in path" :key="node.key" :id='node.id' 
    class="item" @click="openPathItem(node)" @dragenter="handleMove">
        <span :id='node.id' v-if="node.type == 'folder'" class="material-symbols-outlined">folder</span>
        <span :id='node.id' v-else-if="node.type == 'root'" class="material-symbols-outlined">database</span>
        <span :id='node.id' v-else class="material-symbols-outlined">draft</span> 
        <span :id='node.id'>{{ node.label }} </span>
        <span class="material-symbols-outlined">chevron_right</span>
    </div>
  </VueDraggable>
  </div>
  <div class="treeContainer">
      <Tree  
        v-if="treeData.length"
        :treeData = "treeData"
        :hoveredPathItem = "hoveredPathItem"
        @moveItem="moveItem" 
        @openItem="openItem"
        @deleteItem = "deleteItem"
        @updateTree = "fetchData"
        />
  </div>
</div>
</template>

<script>
import { useStore } from 'vuex';
import { ref, onMounted, watch} from 'vue';
import Tree from './DbTree.vue';
import { buildTreeData } from '@/utils/treeHelpers/buildTreeData';
import { VueDraggable } from 'vue-draggable-plus';
import { deleteMail } from '@/utils/db/deleteMail';
import { deleteFolder } from '@/utils/db/deleteFolder';

export default {
  name: 'TreeWrapper',
  components: { Tree, VueDraggable },
  setup() {
  const path = ref([
    {key: 'root', 
    id: 0,
    label: 'root',
    type: 'root',
    expanded: true
  }])

  const pathContainer = ref(null);
  const hoveredPathItem = ref(null)
  const treeData = ref([]);
  const store = useStore();
  

  const createFolder = async () => {
    const folderName = prompt("Neuen Ordnernamen eingeben:");
    const level = path.value[path.value.length - 1].id
    if (!folderName) return;
    try {
      const response = await fetch('https://html-creator.demo.cartago.com/api/folders', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: folderName, parent_id: level })
      });

      if (response.ok) {
        fetchData()
      }
    } catch (error) {
      console.error('Fehler beim Erstellen des Ordners:', error);
    }
  };

  const openNew = async () => {
    await store.dispatch('updateExampleMail', '/emptyMail.json')
    store.commit('setView', 'Edit')
    await store.dispatch('resetEmailTitle')
    await store.dispatch('resetSharedData')
    await fetchData()
}

  const openItem = (item) => {
    path.value.push(item)
    store.dispatch('updateFolderId', item.id)
    fetchData()
  }

  const handleMove = (event) => {
      if(event.target.getAttribute("id")){
        const hoveredId = event.target.getAttribute("id")
        hoveredPathItem.value = path.value.find((item) => item.id == hoveredId)
        } 
        console.log(hoveredPathItem.value)
      }

  const openPathItem = (item) => {
    console.log(item)
    const index = path.value.findIndex(node => node.key === item.key);
    if (index !== -1) {
      path.value = path.value.slice(0, index + 1); // 🔥 Kürzt den Path bis zum gewählten Item
    } 
    store.dispatch('updateFolderId', item.id)
    fetchData()
};


    // Drag & Drop: Element verschieben
    const moveItem = async (item, newParent) => {
      const itemId = Number(item.key.split('-')[1]);
      const newParentId = newParent?.key.startsWith('folder-') ? Number(newParent.key.split('-')[1]) : null;
      console.log(itemId, newParentId)
      try {
        const response = await fetch('https://html-creator.demo.cartago.com/api/folders/move', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ item_id: itemId, type: item.type, new_parent_id: newParentId })
        });
        if (response.ok) fetchData()
    } catch (error) {
        console.error('Fehler beim Verschieben:', error);
      }
      
    };

    // API: Lade E-Mails & Ordner
      const fetchData = async () => {
            try {
                const level =  path.value[path.value.length - 1].id
                const response = await fetch(`https://html-creator.demo.cartago.com/api/folders/folderLevel/${level}`);
                const data = await response.json();  
                const emails = data.emails;  
                const folders = data.folders; 

                treeData.value = buildTreeData(emails, folders);
            } catch (error) {
                console.error('Fehler beim Laden der Daten:', error);
            }
        };

      const deleteItem = async key => {
        if (key.startsWith('folder')){
          const id = Number(key.split('-')[1]);
          await deleteFolder(id);
          fetchData()
        }
        if (key.startsWith('email')){
          const id = Number(key.split('-')[1]);
          await deleteMail(id);
          fetchData()
        }else{
          console.log('Root nicht löschbar')
        }
      };

     watch(path, (newValue) => {
      store.commit('updatePath', newValue);  // Mutation aufrufen
    });

    onMounted(fetchData);

    return {
      moveItem,
      createFolder,
      openNew,
      openItem,
      openPathItem,
      handleMove,
      hoveredPathItem,
      path,
      pathContainer,
      fetchData,
      deleteItem,
      treeData
    };
  }
};
</script>

<style scoped>
.container{
  display: grid;
  gap: 0px;
  grid-template-columns: auto auto auto auto auto;
  justify-content: left;
}
.path {
display: flex; 
overflow-x: auto;         
align-items: center;       
white-space: nowrap;      
width: 100%;    
max-width: 100%;      
background: #1e2a36; 
padding: 2px 0px;     
}

.item {
display: flex;            
align-items: center;     
padding: 1px 0px;        
background: transparent;        
border-radius: 3px;      
white-space: nowrap; 
font-size: 14px;     
}

.item .material-symbols-outlined  {
  font-size: 18px;
}

.item:hover{
  background-color: rgb(214, 214, 214);
  cursor: pointer
}

/* Symbole innerhalb von Items */
.item .material-symbols-outlined {
margin-right: 5px; /* 🔥 Abstand zwischen Symbol und Text */
}

.actions{
  padding: 2px;
  display:flex;
  align-items: center;
}

.dbButton {
  color:#ccc;
}

.newFile{
  font-size: 22px;
}

.dbButton:hover {
  color: white;
  cursor: pointer;
}

.fileSystem {
  background: #243342;
  box-shadow: rgba(255, 255, 255, 0.02) 0px 1px 3px 0px, rgba(255, 255, 255, 0.15) 0px 0px 0px 1px;
  height: 290px;
  width: 100%;
  max-width: 100%;
  color: white;
}

.treeContainer{
  height: 215px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

/* For Chromium */
.treeContainer::-webkit-scrollbar {
  width: 5px;
  height: 3px;
}

.treeContainer::-webkit-scrollbar-track {
  background-color: transparent
}

.treeContainer::-webkit-scrollbar-thumb {
  background-color: white;
}

.treeContainer:hover::-webkit-scrollbar-thumb {
  background-color: white;
}



 /* For Firefox */
@-moz-document url-prefix() {
 .treeContainer {
  scrollbar-width: thin; /* Controls the width of the scrollbar */
  scrollbar-color: white transparent; /* Thumb and track colors */
}}

.path::-webkit-scrollbar {
  width: 5px;
  height: 3px;
}

.path::-webkit-scrollbar-track {
  background-color: transparent;
}

.path::-webkit-scrollbar-thumb {
  background-color: white;
}

.path:hover::-webkit-scrollbar-thumb {
  background-color: white;
}

@-moz-document url-prefix() {
 .path {
  scrollbar-width: thin;
  scrollbar-color: white transparent;
}} 
</style>
